export default "__VITE_ASSET__DgqdPhqI__"